var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "animated fadeIn reports" },
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "12" } },
                [
                  _c(
                    "b-card",
                    { staticClass: "bg-white", attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-row",
                        {
                          staticClass: "p-0",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "3" } },
                            [_c("h5", [_vm._v("Forms Graph")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "1.5" } },
                            [
                              _c("h6", [
                                _vm._v(_vm._s(_vm.$t("COMMON.DATE_RANGE")))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "3" } },
                            [
                              _c("date-picker", {
                                attrs: {
                                  range: "",
                                  lang: "en",
                                  format: "YYYY-MM-DD",
                                  "append-to-body": "",
                                  clearable: false,
                                  width: "220px"
                                },
                                model: {
                                  value: _vm.formsDateRange,
                                  callback: function($$v) {
                                    _vm.formsDateRange = $$v
                                  },
                                  expression: "formsDateRange"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "1" } },
                            [
                              _c(
                                "b-button",
                                { on: { click: _vm.fetchCounts } },
                                [_vm._v("Fetch")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "2" } },
                            [
                              _c(
                                "b-button",
                                { on: { click: _vm.downloadFormsGraphPDF } },
                                [_vm._v("Download PDF")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card-body",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12", lg: "12" } },
                                [
                                  _c(
                                    "b-card",
                                    {
                                      staticClass: "chart-card",
                                      attrs: {
                                        "no-body": "",
                                        id: "processed-forms-chart"
                                      }
                                    },
                                    [
                                      _c(
                                        "b-card-body",
                                        { staticClass: "chart-card-body" },
                                        [
                                          _c(
                                            "h6",
                                            { staticClass: "chart-title" },
                                            [_vm._v("Processed Forms Count")]
                                          ),
                                          _vm._v(" "),
                                          _c("BarChart", {
                                            attrs: {
                                              "bar-labels": _vm.formChartLabels,
                                              "bar-data":
                                                _vm.formChartDataPoints,
                                              "y-step-size":
                                                _vm.processedFormsYStepSize,
                                              "y-max": _vm.processedFormsYMax,
                                              "dataset-label": _vm.$t(
                                                "ANALYTICS.FORM_COUNT"
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card-body",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12", lg: "12" } },
                                [
                                  _c(
                                    "b-card",
                                    {
                                      staticClass: "chart-card",
                                      attrs: {
                                        "no-body": "",
                                        id: "unique-users-chart"
                                      }
                                    },
                                    [
                                      _c(
                                        "b-card-body",
                                        { staticClass: "chart-card-body" },
                                        [
                                          _c(
                                            "h6",
                                            { staticClass: "chart-title" },
                                            [_vm._v("Unique Users Count")]
                                          ),
                                          _vm._v(" "),
                                          _c("BarChart", {
                                            attrs: {
                                              "bar-labels": _vm.userChartLabels,
                                              "bar-data":
                                                _vm.userChartDataPoints,
                                              "y-step-size":
                                                _vm.uniqueUsersYStepSize,
                                              "y-max": _vm.uniqueUsersYMax,
                                              "dataset-label": _vm.$t(
                                                "ANALYTICS.USER_COUNT"
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { lg: "12" } },
                [
                  _c(
                    "b-card",
                    { staticClass: "bg-white", attrs: { "no-body": "" } },
                    [
                      _c(
                        "b-row",
                        {
                          staticClass: "p-0",
                          attrs: { slot: "header" },
                          slot: "header"
                        },
                        [
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "3" } },
                            [_c("h5", [_vm._v("Forms Tables")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "1" } },
                            [
                              _c("h6", [
                                _vm._v(_vm._s(_vm.$t("COMMON.DATE_RANGE")))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "3" } },
                            [
                              _c("date-picker", {
                                attrs: {
                                  range: "",
                                  lang: "en",
                                  format: "YYYY-MM-DD",
                                  "append-to-body": "",
                                  clearable: false,
                                  width: "220px"
                                },
                                model: {
                                  value: _vm.tablesDateRange,
                                  callback: function($$v) {
                                    _vm.tablesDateRange = $$v
                                  },
                                  expression: "tablesDateRange"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "2" } },
                            [_c("h6", [_vm._v("Filter by Brand")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "2" } },
                            [
                              _c("b-form-select", {
                                attrs: { options: _vm.allBrandOptions },
                                model: {
                                  value: _vm.selectedBrand,
                                  callback: function($$v) {
                                    _vm.selectedBrand = $$v
                                  },
                                  expression: "selectedBrand"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "mt-auto", attrs: { sm: "1" } },
                            [
                              _c(
                                "b-button",
                                { on: { click: _vm.fetchBrandsData } },
                                [_vm._v("Fetch")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-card-body",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12", lg: "12" } },
                                [
                                  _c(
                                    "b-card",
                                    {
                                      staticClass: "table-card",
                                      attrs: {
                                        "no-body": "",
                                        "bg-variant": "light"
                                      }
                                    },
                                    [
                                      _c(
                                        "b-card-header",
                                        { staticClass: "table-subheader" },
                                        [
                                          _c(
                                            "b-row",
                                            {
                                              staticClass:
                                                "p-0 align-items-center"
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { sm: "8" } },
                                                [
                                                  _c(
                                                    "h6",
                                                    { staticClass: "mb-0" },
                                                    [
                                                      _vm._v(
                                                        "Brands Analysis Table"
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass: "mt-1",
                                                  attrs: { sm: "2" }
                                                },
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      on: {
                                                        click:
                                                          _vm.downloadBrandsTable
                                                      }
                                                    },
                                                    [_vm._v("Download CSV")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-card-body",
                                        { staticClass: "p-3" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "report-table" },
                                            [
                                              _c("b-table", {
                                                attrs: {
                                                  "show-empty": "",
                                                  striped: "",
                                                  "empty-text": _vm.$t(
                                                    "COMMON.NO_RECORD"
                                                  ),
                                                  hover: "",
                                                  responsive: "sm",
                                                  items:
                                                    _vm.filteredBrandFields,
                                                  fields: _vm.brandTableFields,
                                                  "sort-by": _vm.brandSortBy,
                                                  "sort-desc": _vm.brandSortDesc
                                                },
                                                on: {
                                                  "update:sortBy": function(
                                                    $event
                                                  ) {
                                                    _vm.brandSortBy = $event
                                                  },
                                                  "update:sortDesc": function(
                                                    $event
                                                  ) {
                                                    _vm.brandSortDesc = $event
                                                  }
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "HEAD_month",
                                                    fn: function(data) {
                                                      return [
                                                        _c("em", [
                                                          _vm._v(
                                                            _vm._s(data.label)
                                                          )
                                                        ])
                                                      ]
                                                    }
                                                  },
                                                  {
                                                    key: "HEAD_brand",
                                                    fn: function(data) {
                                                      return [
                                                        _c("em", [
                                                          _vm._v(
                                                            _vm._s(data.label)
                                                          )
                                                        ])
                                                      ]
                                                    }
                                                  },
                                                  {
                                                    key:
                                                      "HEAD_avg_transcribed_fields",
                                                    fn: function(data) {
                                                      return [
                                                        _c("em", [
                                                          _vm._v(
                                                            _vm._s(data.label)
                                                          )
                                                        ])
                                                      ]
                                                    }
                                                  },
                                                  {
                                                    key:
                                                      "HEAD_avg_edited_fields",
                                                    fn: function(data) {
                                                      return [
                                                        _c("em", [
                                                          _vm._v(
                                                            _vm._s(data.label)
                                                          )
                                                        ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              }),
                                              _vm._v(" "),
                                              !_vm.showBrandsTable
                                                ? _c(
                                                    "content-placeholders",
                                                    [
                                                      _c(
                                                        "content-placeholders-text",
                                                        { attrs: { lines: 12 } }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mt-4" },
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12", lg: "12" } },
                                [
                                  _c(
                                    "b-card",
                                    {
                                      staticClass: "table-card",
                                      attrs: {
                                        "no-body": "",
                                        "bg-variant": "light"
                                      }
                                    },
                                    [
                                      _c(
                                        "b-card-header",
                                        { staticClass: "table-subheader" },
                                        [
                                          _c(
                                            "b-row",
                                            {
                                              staticClass:
                                                "p-0 align-items-center"
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                { attrs: { sm: "8" } },
                                                [
                                                  _c(
                                                    "h6",
                                                    { staticClass: "mb-0" },
                                                    [
                                                      _vm._v(
                                                        "Most Edited Fields Table " +
                                                          _vm._s(
                                                            _vm.appliedBrandFilter
                                                              ? "- " +
                                                                _vm.appliedBrandFilter
                                                              : "- All Brands"
                                                          )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass: "mt-1",
                                                  attrs: { sm: "2" }
                                                },
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      on: {
                                                        click:
                                                          _vm.downloadEditedFieldsTable
                                                      }
                                                    },
                                                    [_vm._v("Download CSV")]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-card-body",
                                        { staticClass: "p-3" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "report-table" },
                                            [
                                              _c("b-table", {
                                                attrs: {
                                                  "show-empty": "",
                                                  striped: "",
                                                  "empty-text": _vm.$t(
                                                    "COMMON.NO_RECORD"
                                                  ),
                                                  hover: "",
                                                  responsive: "sm",
                                                  items: _vm.topEditedFields,
                                                  fields:
                                                    _vm.editedFieldsTableFields
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "HEAD_s_no",
                                                    fn: function(data) {
                                                      return [
                                                        _c("em", [
                                                          _vm._v(
                                                            _vm._s(data.label)
                                                          )
                                                        ])
                                                      ]
                                                    }
                                                  },
                                                  {
                                                    key: "HEAD_field_name",
                                                    fn: function(data) {
                                                      return [
                                                        _c("em", [
                                                          _vm._v(
                                                            _vm._s(data.label)
                                                          )
                                                        ])
                                                      ]
                                                    }
                                                  },
                                                  {
                                                    key: "HEAD_edit_count",
                                                    fn: function(data) {
                                                      return [
                                                        _c("em", [
                                                          _vm._v(
                                                            _vm._s(data.label)
                                                          )
                                                        ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              }),
                                              _vm._v(" "),
                                              !_vm.showBrandsTable
                                                ? _c(
                                                    "content-placeholders",
                                                    [
                                                      _c(
                                                        "content-placeholders-text",
                                                        { attrs: { lines: 15 } }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0644e4e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0644e4e2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/reports/formsDashboard.vue
// module id = 1262
// module chunks = 2